<form [formGroup]="skjema" (ngSubmit)="lagre()" novalidate>
  <h2 mat-dialog-title>
    @if (erOpprett) {
      {{ "Opprett ny mappe"|translate }}
    } @else {
      {{ "Rediger mappen '{navn}'"|translate:{navn: mappe.navn} }}
    }
  </h2>
  <mat-dialog-content>
    <arkivmappe-skjema [skjema]="skjema" [gruppeId]="mappe.eiendeGruppeId"/>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button type="button" mat-button (click)="avbryt()">{{ "Avbryt" | translate }}</button>
    <submit-button [skjema]="skjema" [arbeidPaagaar]="lagrer()"
                   [spinnerTekst]="erOpprett ? 'Oppretter...':'Lagrer...'|translate">
      {{ erOpprett ? 'Opprett' : 'Lagre'|translate }}
    </submit-button>
  </mat-dialog-actions>
</form>
